import React from 'react';
import { ButtonTs } from '@lt/components';
import { useTranslation } from '@lt/localization';
import styled from 'styled-components';
import { ValidationCommonErrors } from 'src/components/Tourists/components/Validation';

const SubmitCustomerMobile = ({ onSubmit, disabled }) => {
  const { t } = useTranslation();

  return (
    <>
      <ValidationCommonErrors />
      <ButtonContainer>
        <SubmitButton
          variant="primary"
          size="large"
          onClick={() => onSubmit()}
          disabled={disabled}
        >
          {t('checkout.customer.submit_customer_btn')}
        </SubmitButton>
      </ButtonContainer>
    </>
  );
};

const ButtonContainer = styled.div`
  margin-top: 15px;
  margin-bottom: 5px;
  display: flex;
  width: 100%;
  justify-content: center;
`;

const SubmitButton = styled(ButtonTs)`
  width: 100%;
  font-size: 15px;
  white-space: pre-line;
`;

export default SubmitCustomerMobile;
